import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b459fb0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "user-page"
}
const _hoisted_2 = { class: "user-page-header material-card_type_outlined" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "user-page-header__avatar" }, null, -1))
const _hoisted_4 = { class: "user-page-header__data" }
const _hoisted_5 = { class: "user-page-header__name" }
const _hoisted_6 = { class: "user-page-header__status" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "user-page-header__status-text" }
const _hoisted_9 = { class: "status-setter material-card_type_elevated" }
const _hoisted_10 = { class: "status-setter-element" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "status-setter-element" }
const _hoisted_13 = ["src"]

import { GetStudentMenuPageResponseModel } from '@/http/pageModels/studentModels/menuPage/GetStudentMenuPageResponseModel';
import { StudentStatus } from '@/http/pageModels/teacherModels/classPage/AbsentStudentsResponseModel';
import { reactive, computed, onMounted } from 'vue';
import { getStudentMenuPage, postSetStatus } from './apiMethods';
import CustomButton from '@/common/components/snedson-material-components/custom-button/custom-button.vue';
import ListSelect from '@/common/components/snedson-material-components/list-select/list-select.vue';
import checkMarkIcon from '@/assets/icons/check-mark.png';
import speechBalloonIcon from '@/assets/icons/speech-balloon.png';
import { IListSelectMenuItem } from '@/common/components/snedson-material-components/list-select/list-select.types';
import TextField from '@/common/components/snedson-material-components/text-field/text-field.vue';
import { getBaseUrl } from '@/http/api/';


export default /*#__PURE__*/_defineComponent({
  __name: 'SetStatusPage',
  setup(__props) {

const state = reactive<{
    data: GetStudentMenuPageResponseModel | null;
    selectedStatusId: number | null;
    comment: string;
}>({
    data: null,
    selectedStatusId: null,
    comment: '',
});

const currentStatus = computed((): StudentStatus | null => {
    if (!state.data) {
        return null;
    }

    return state.data?.allStatusesForStudents[
        state.data.allStatusesForStudents.findIndex(
            (value) => value.statusID === state.data?.currentStatusID
        )
    ];
});

const onStatusSelect = (statusId: number | null) => {
    state.selectedStatusId = statusId;
};

const statusesForListSelect = computed((): IListSelectMenuItem[] | null => {
    return state.data !== null
        ? state.data.allStatusesForStudents.map((value) => {
              return { id: value.statusID, title: value.statusName };
          })
        : null;
});

const setStatus = () => {
    if (state.data?.currentStatusID == state.selectedStatusId) {
        alert('У вас уже установлен данный статус');
        return;
    }

    if (state.selectedStatusId) {
        postSetStatus({
            statusId: state.selectedStatusId,
            comment: state.comment,
        });
    }
};

onMounted(() => {
    getStudentMenuPage().then((res) => {
        state.data = res.data;
        state.selectedStatusId = res.data.currentStatusID;
    });
});

return (_ctx: any,_cache: any) => {
  return (state.data !== null && state.selectedStatusId !== null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h1", _hoisted_5, _toDisplayString(state.data.name) + " " + _toDisplayString(state.data.surname), 1),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("img", {
                src: `${_unref(getBaseUrl)}${_unref(currentStatus)?.iconURL}`,
                alt: "",
                class: "user-page-header__status-icon"
              }, null, 8, _hoisted_7),
              _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(currentStatus)?.statusName), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("img", {
              src: _unref(checkMarkIcon),
              alt: "",
              class: "status-setter-element__icon"
            }, null, 8, _hoisted_11),
            _createVNode(ListSelect, {
              props: {
                        menuItems: _unref(statusesForListSelect)
                            ? _unref(statusesForListSelect)
                            : [],
                        isDefaultSelectionAvaliable: false,
                        selectedItemId: state.selectedStatusId,
                        title: 'Статус',
                    },
              onSelected: onStatusSelect
            }, null, 8, ["props"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("img", {
              src: _unref(speechBalloonIcon),
              alt: ""
            }, null, 8, _hoisted_13),
            _createVNode(TextField, {
              type: "text",
              placeholder: 'Коротко опишите причину...',
              modelValue: state.comment,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.comment) = $event))
            }, null, 8, ["placeholder", "modelValue"])
          ])
        ]),
        _createVNode(CustomButton, {
          props: {
                iconName: 'person_pin_circle',
                innerText: 'Установить статус',
                size: 'full',
                type: 'filled',
            },
          onClick: setStatus
        })
      ]))
    : _createCommentVNode("", true)
}
}

})